//
// Core requirement
//
// This is the "core" of our website. 
// This should require everything necessary for 
// our site, but nothing unused.
//

// Unsupported Browser Redirect
require("unsupported-browser/redirect.js");

// Element-Query
require("element-query/element-query.js");

// Event CSS Modifier
require("event-css-modifier/event-css-modifier.js");

// This module is used to disable CSS transition while 
// the page is loading. This prevent unwanted CSS transition
// while the DOM is initialize.
require("disable-transition-onload");

// Modules
require("section/burger"); // header
require("section/newsletter");
require("section/footer");
require("section/popup");
require("section/tour-nav");
require("section/next-page");
require("section/pricing");
require("section/heading");
require("section/news-list");
require("section/news");

require("block/paragraphe");
require("block/image");
require("block/jumbotron");
require("block/avantages");
require("block/organisations");
require("block/introduction");
require("block/information");
require("block/liste");
require("block/cta");
require("block/img-text");
require("block/text-detail");
require("block/faq");
require("block/contact");
require("block/map");
require("block/quote");
require("block/newsletter-form");
require("block/confirmation");
require("block/videos");

// Required for documentation
//require("webstrap/code");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/core.js
 ** module id = 17
 ** module chunks = 0 1
 **/